const Fields = [
  { name: "companyId", label: "Company Name", select: true },
  { name: "siteId", label: "Site Name", select: true },
  { name: "isFailure", checkbox: true, label: "Failure" },
  { label: "From", name: "fromDate", date: true },
  { label: "To", name: "toDate", date: true },
];
export default Fields;

const OdooAccountFields = [
  {
    name: "number",
    label: "Number",
    required: true,
    validationType: "string",
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    name: "title",
    label: "Title",
    required: true,
    validationType: "string",
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  { name: "typeId", label: "Type", select: true },
  {
    name: "isActive",
    label: "Account Status",
    switch: true,
    validationType: "boolean",
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  // {
  //   name: "locked",
  //   label: "Locked",
  //   switch: true,
  //   validationType: "boolean",
  //   validations: [
  //     {
  //       type: "required",
  //       params: ["this field is required"],
  //     },
  //   ],
  // },
];
export { OdooAccountFields }; 